export const QUOTA_EXCEEDED_CODE = 22;
